export default {
  meta: {
    title: '招商资源管理'
  }
};
